import React from 'react';
import Nav from './Nav';
import { Header } from './ProjectPageStyledComponents';


const ProjectPageHeader = () => {
    return (
        <Header>
            <Nav other />
        </Header>
    );
}

export default ProjectPageHeader;